// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
// import Footer from "./Footer";
// import Navbar from "./Navbar";

// const sections = [
//   {
//     number: "1",
//     title: "Introduction and Scope",
//     content: `Furbabies Inc. ("Furbabies", "we", "us", "our") is committed to protecting your privacy and the privacy of your pet-related data. This Privacy Policy describes how we collect, use, disclose, store, and protect personal information when you use the Furbabies.AI platform, website, mobile applications, Furbot chatbot, and all related services (collectively, the "Service").

// This Policy applies to all users of the Service globally, including users accessing the Service in its available languages: English, Mandarin Chinese, Spanish, Hindi, French, Arabic, Farsi, Bengali, Russian, Portuguese, Urdu, and Telugu. We comply with applicable privacy and data protection laws in all major jurisdictions in which users access the Service, including GDPR, CCPA/CPRA, LGPD, PIPEDA, India's DPDPA, and other applicable laws.`,
//   },
//   {
//     number: "2",
//     title: "Data Controller Information",
//     content: `The data controller responsible for your personal data is:

// Furbabies Inc.
// 495 Grand Blvd #206, Miramar Beach, FL 32550, United States
// Email: social@furbabies.ai

// For EU/EEA data subjects: Furbabies Inc. serves as both data controller and, where applicable, data processor for services performed on your behalf. EU/EEA users may designate Furbabies as their representative under Article 27 of the GDPR by contacting us at social@furbabies.ai. We are in the process of appointing a formal EU GDPR representative and will update this Policy accordingly.`,
//   },
//   {
//     number: "3",
//     title: "Information We Collect",
//     subsections: [
//       {
//         title: "3.1 Information You Provide Directly",
//         content: `We collect the following categories of personal information that you voluntarily provide to us:

// • Account Registration Data: Your name, email address, and password when you create an account.
// • Payment Information: Credit or debit card information, billing address, and related payment data. Note: Full payment card data is processed and stored exclusively by Stripe, Inc.; Furbabies retains only tokenized payment identifiers.
// • Pet Registration Data: Species, breed, age, weight, sex, health history, dietary restrictions, and other information about your pet(s) that you choose to provide.
// • User Content: All photos, videos, and other media you upload to the Service, including images of your pet, pet excretions, skin conditions, food items, and nutritional labels.
// • Chat and Interaction Data: All messages, queries, and interactions you have with the Service, including Furbot chatbot conversations.
// • Communications: Any emails, messages, or other communications you send to us at social@furbabies.ai or through the Service.`,
//       },
//       {
//         title: "3.2 Information Collected Automatically",
//         content: `When you use the Service, we automatically collect:

// • Device and Technical Data: IP address, device type, operating system, browser type and version, device identifiers.
// • Usage Data: Pages visited, features used, time and duration of access, referring URLs, clickstream data.
// • Location Data: General geographic location inferred from IP address (we do not collect precise GPS location unless you provide it).
// • Cookies and Tracking Technologies: As described in our Cookie Policy.`,
//       },
//       {
//         title: "3.3 Special Categories of Data",
//         content: `Uploaded images and videos of pets may incidentally contain images of you or other individuals. We treat such incidentally collected biometric or personal data with heightened care. We do not intentionally collect health data about humans; however, to the extent any human health-related information is included in uploaded content, we treat such data as sensitive personal information subject to additional protections.`,
//       },
//     ],
//   },
//   {
//     number: "4",
//     title: "How We Use Your Information",
//     content: `We use the information we collect for the following purposes:

// • Service Delivery: To provide, operate, and personalize the Furbabies.AI Service, including processing uploaded content through AI models to generate pet health and nutrition guidance.
// • Account Management: To create and manage your account, process your subscription, and provide customer support.
// • Payment Processing: To facilitate subscription billing through Stripe.
// • AI Model Training and Research: To train, improve, test, and develop our AI models and algorithms. All uploaded photos, videos, and chat data are stored for research and commercial development purposes. Where required by applicable law, we rely on your explicit consent or legitimate interests as the legal basis for this use.
// • Commercial Purposes: To develop new products and services, improve existing features, and analyze usage patterns for business development.
// • Communications: To send you service-related notices, subscription confirmations, updates to our policies, and—where you have opted in—promotional communications.
// • Legal Compliance: To comply with applicable laws, respond to lawful requests from authorities, enforce our Terms and Conditions, and protect our legal rights.
// • Safety and Fraud Prevention: To detect, investigate, and prevent fraudulent or illegal activity and to ensure the security of the Service.`,
//   },
//   {
//     number: "5",
//     title: "Legal Bases for Processing (GDPR / Global)",
//     content: `For users in the European Economic Area (EEA), United Kingdom, and other jurisdictions requiring a specified legal basis for personal data processing, we process your data under the following legal bases:

// • Performance of Contract (Art. 6(1)(b) GDPR): Processing necessary to deliver the Service you have contracted for, including account creation, subscription management, and AI-generated pet guidance.
// • Legitimate Interests (Art. 6(1)(f) GDPR): Processing for AI model improvement, fraud prevention, security, and general business development, where our interests do not override your fundamental rights.
// • Consent (Art. 6(1)(a) GDPR): Where we rely on consent, including for marketing communications, AI training on your specific content where required, and cookie usage. You may withdraw consent at any time.
// • Legal Obligation (Art. 6(1)(c) GDPR): Where processing is required by applicable law.
// • Special Categories (Art. 9 GDPR): To the extent any uploaded content constitutes special category data, we process such data based on your explicit consent.`,
//   },
//   {
//     number: "6",
//     title: "Data Sharing and Disclosure",
//     subsections: [
//       {
//         title: "6.1 Service Providers",
//         content: `We share personal data with trusted third-party service providers who assist in operating the Service, including Stripe, Inc. for payment processing; AI Model Providers who power the Service's AI functionality; Cloud Storage and Infrastructure Providers for secure hosting; and Analytics Providers for usage analytics and service improvement. All service providers are contractually required to process personal data only as instructed by Furbabies.`,
//       },
//       {
//         title: "6.2 Research Partners and Commercial Use",
//         content: `Consistent with our Terms and Conditions, aggregated or de-identified data derived from user interactions, uploaded content, and AI model outputs may be shared with research partners, academic institutions, or commercial partners. We will not share individually identifiable personal information for such purposes without your explicit consent, except as described in this Policy.`,
//       },
//       {
//         title: "6.3 Legal and Safety Disclosures",
//         content: `We may disclose your personal data if required to do so by law, subpoena, court order, or governmental authority, or if we believe disclosure is necessary to protect our rights, protect your safety or the safety of others, investigate fraud, or respond to a government request.`,
//       },
//       {
//         title: "6.4 Business Transfers",
//         content: `In the event of a merger, acquisition, reorganization, bankruptcy, or sale of all or a portion of our assets, your personal data may be transferred to the acquiring entity. We will provide notice of any such transfer and of any material changes to the privacy practices applicable to your data.`,
//       },
//       {
//         title: "6.5 No Sale of Personal Data",
//         content: `Furbabies does not sell, rent, or lease your personal information to third parties for their independent marketing purposes. For California users, we do not "sell" or "share" personal information as those terms are defined under the CCPA/CPRA, except as otherwise disclosed in this Policy.`,
//       },
//     ],
//   },
//   {
//     number: "7",
//     title: "International Data Transfers",
//     content: `Furbabies is based in the United States. If you are accessing the Service from outside the United States, your personal data will be transferred to, stored in, and processed in the United States. We implement appropriate safeguards to ensure that transfers of personal data from the EU/EEA, UK, Switzerland, and other jurisdictions are conducted in compliance with applicable data transfer requirements.

// For transfers of EU/EEA personal data to the United States, we rely on Standard Contractual Clauses (SCCs) approved by the European Commission, Binding Corporate Rules where applicable, and any adequacy decisions issued by relevant authorities.`,
//   },
//   {
//     number: "8",
//     title: "Data Retention",
//     content: `We retain your personal data for as long as your account remains active and for such period as may be necessary to fulfill the purposes described in this Policy. Specifically:

// • Account and Registration Data: Retained for the duration of your account and for seven (7) years following account closure.
// • Uploaded Photos, Videos, and Chats: Retained indefinitely for research and commercial purposes, unless you request deletion and deletion is not precluded by legal obligation.
// • Payment Records: Retained for seven (7) years as required by financial regulations.
// • Communications: Retained for five (5) years.

// You may request deletion of your personal data as described in Section 9 below.`,
//   },
//   {
//     number: "9",
//     title: "Your Privacy Rights",
//     subsections: [
//       {
//         title: "9.1 Rights Available to All Users",
//         content: `Regardless of your location, you have the right to: Access (request a copy of personal data we hold), Correction (request correction of inaccurate data), Deletion (request deletion, subject to lawful retention requirements), and Opt-Out of Marketing (opt out of promotional communications at any time).`,
//       },
//       {
//         title: "9.2 Additional Rights for EEA / UK Users (GDPR / UK GDPR)",
//         content: `If you are located in the EEA or the UK, you additionally have the right to: Restriction of Processing, Data Portability, Objection to processing based on legitimate interests, protection from solely Automated Decision-Making, and to Lodge a Complaint with your local data protection supervisory authority.`,
//       },
//       {
//         title: "9.3 California Rights (CCPA/CPRA)",
//         content: `California residents have the right to: Know (disclosure of categories and specific pieces of personal information collected), Delete, Correct, Opt-Out of Sale/Sharing, Limit Use of Sensitive Personal Information, and Non-Discrimination for exercising privacy rights.`,
//       },
//       {
//         title: "9.4 Brazilian Rights (LGPD)",
//         content: `Brazilian users have the right to confirmation of processing, access, correction, anonymization or deletion, portability, information about sharing, the right to not consent or to revoke consent, and to lodge a complaint with Brazil's National Data Protection Authority (ANPD).`,
//       },
//       {
//         title: "9.5 Exercising Your Rights",
//         content: `To exercise any of the rights described in this section, please submit a verifiable request to us at social@furbabies.ai. We will respond to all valid requests within the timeframe required by applicable law (generally thirty (30) to forty-five (45) days, subject to extension where permitted).`,
//       },
//     ],
//   },
//   {
//     number: "10",
//     title: "Children's Privacy",
//     content: `The Service is not directed to individuals under the age of 18. We do not knowingly collect personal information from children under 18. If you become aware that a child has provided us with personal information, please contact us at social@furbabies.ai and we will take steps to delete such information.`,
//   },
//   {
//     number: "11",
//     title: "Data Security",
//     content: `We implement commercially reasonable technical and organizational security measures designed to protect your personal data from unauthorized access, use, disclosure, alteration, or destruction. These measures include encryption of data in transit (TLS/SSL), access controls, secure cloud infrastructure, and regular security assessments. However, no method of transmission over the Internet is completely secure, and we cannot guarantee absolute security of your data.

// In the event of a data breach that is likely to result in a risk to your rights and freedoms, we will notify you and relevant authorities as required by applicable law (e.g., within 72 hours under GDPR).`,
//   },
//   {
//     number: "12",
//     title: "Jurisdiction-Specific Provisions",
//     content: `• EU/EEA: Our processing activities are subject to GDPR and the supervision of relevant EU data protection authorities.
// • United Kingdom: We comply with the UK GDPR and the Data Protection Act 2018. UK users may contact the Information Commissioner's Office (ICO).
// • Canada: We comply with PIPEDA and applicable provincial privacy laws. Canadian users may contact the Office of the Privacy Commissioner of Canada.
// • India: We comply with India's Digital Personal Data Protection Act (DPDPA) to the extent applicable.
// • Australia: We comply with the Australian Privacy Act 1988 and the Australian Privacy Principles. Australian users may contact the Office of the Australian Information Commissioner (OAIC).`,
//   },
//   {
//     number: "13",
//     title: "Cookies and Tracking",
//     content: `We use cookies and similar tracking technologies as described in our separate Cookie Policy, which is incorporated herein by reference. You can manage your cookie preferences through your browser settings or our cookie consent management tool.`,
//   },
//   {
//     number: "14",
//     title: "Changes to This Privacy Policy",
//     content: `We may update this Privacy Policy from time to time to reflect changes in our data practices, applicable law, or business operations. We will provide notice of material changes by posting the updated Policy on the Service and updating the effective date. For significant changes, we will also provide notice by email. Your continued use of the Service after the effective date of any updated Policy constitutes your acceptance of the changes.`,
//   },
//   {
//     number: "15",
//     title: "Contact Us",
//     content: `If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:

// Furbabies Inc.
// 495 Grand Blvd #206, Miramar Beach, FL 32550
// Email: social@furbabies.ai

// We will respond to all privacy-related inquiries within thirty (30) days.`,
//   },
// ];

// const SectionBlock = ({ section, index }) => {
//   const [open, setOpen] = useState(true);

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       viewport={{ once: true }}
//       transition={{ duration: 0.5, delay: index * 0.05 }}
//       className="mb-4 rounded-2xl overflow-hidden border border-[#e8ddd6]"
//     >
//       <button
//         onClick={() => setOpen(!open)}
//         className="w-full flex items-center justify-between px-6 py-4 bg-[#f4ede7] hover:bg-[#ede4db] transition-colors text-left"
//       >
//         <div className="flex items-center gap-4">
//           <span className="w-8 h-8 rounded-full bg-[#967d6c] text-white text-sm font-bold flex items-center justify-center flex-shrink-0">
//             {section.number}
//           </span>
//           <h2 className="text-lg font-bold text-gray-800">{section.title}</h2>
//         </div>
//         <span className={`text-[#967d6c] text-xl transition-transform duration-200 ${open ? "rotate-180" : ""}`}>
//           ▾
//         </span>
//       </button>

//       {open && (
//         <div className="px-6 py-5 bg-white">
//           {section.content && (
//             <p className="text-gray-600 poppins-text text-sm leading-7 whitespace-pre-line">{section.content}</p>
//           )}
//           {section.subsections && section.subsections.map((sub, i) => (
//             <div key={i} className={`mb-5 last:mb-0 ${sub.highlight ? "bg-[#fdf8f5] border-l-4 border-[#967d6c] pl-4 pr-3 py-3 rounded-r-xl" : ""}`}>
//               <h3 className="text-sm font-bold text-gray-800 mb-2">{sub.title}</h3>
//               <p className="text-gray-600 poppins-text text-sm leading-7 whitespace-pre-line">{sub.content}</p>
//             </div>
//           ))}
//         </div>
//       )}
//     </motion.div>
//   );
// };

// const PrivacyPolicy = () => {
//   return (
//     <>
//       <Helmet>
//         <title>Privacy Policy — Furbabies.AI</title>
//         <meta name="description" content="Read the Furbabies.AI Privacy Policy to understand how we collect, use, and protect your data." />
//       </Helmet>

//       <Navbar />

//       <div className="min-h-screen bg-white pt-28 pb-16">
//         <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

//           {/* Header */}
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.7 }}
//             className="mb-12 text-center mt-20"
//           >
//             <p className="text-[#967d6c] font-semibold poppins-text text-sm uppercase tracking-widest mb-3">Legal</p>
//             <h1 className="text-5xl lg:text-[60px] lg:leading-[70px] font-bold text-gray-900 mb-4">
//               Privacy Policy
//             </h1>
//             <p className="poppins-text text-gray-500 text-sm">
//               Effective Date: March 10, 2026 &nbsp;·&nbsp; Last Updated: March 10, 2026
//             </p>
//             <div className="mt-4 inline-block bg-[#fdf8f5] border border-[#e8ddd6] rounded-full px-5 py-2">
//               <p className="text-xs poppins-text text-gray-500">
//                 Furbabies Inc. · 495 Grand Blvd #206, Miramar Beach, FL 32550 ·{" "}
//                 <a href="mailto:social@furbabies.ai" className="text-[#967d6c] hover:underline">social@furbabies.ai</a>
//               </p>
//             </div>
//           </motion.div>

//           {/* Intro notice */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.3, duration: 0.6 }}
//             className="mb-8 bg-[#f4ede7] border border-[#e8ddd6] rounded-2xl px-6 py-5"
//           >
//             <p className="text-sm text-gray-700 poppins-text leading-7">
//               This Privacy Policy explains how Furbabies Inc. collects, uses, shares, and protects your personal
//               information and that of your pet(s). Please read this policy carefully.
//             </p>
//           </motion.div>

//           {sections.map((section, i) => (
//             <SectionBlock key={i} section={section} index={i} />
//           ))}

//           {/* Related links */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4"
//           >
//             {[
//               { label: "Terms & Conditions", to: "/terms", desc: "Our terms of service and user agreement" },
//               { label: "Cookie Policy", to: "/cookie-policy", desc: "How we use cookies and tracking" },
//             ].map((item) => (
//               <Link key={item.to} to={item.to}
//                 className="flex items-center justify-between bg-[#f4ede7] hover:bg-[#ede4db] transition-colors rounded-2xl px-6 py-4 group">
//                 <div>
//                   <p className="font-bold text-gray-800 text-sm">{item.label}</p>
//                   <p className="text-xs text-gray-500 poppins-text mt-0.5">{item.desc}</p>
//                 </div>
//                 <span className="text-[#967d6c] text-lg group-hover:translate-x-1 transition-transform">→</span>
//               </Link>
//             ))}
//           </motion.div>

//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default PrivacyPolicy;

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Footer from "./Footer";
import Navbar from "./Navbar";

const sections = [
  {
    number: "1",
    title: "Introduction and Scope",
    content: `Furbabies Inc. ("Furbabies", "we", "us", "our") is committed to protecting your privacy and the privacy of your pet-related data. This Privacy Policy describes how we collect, use, disclose, store, and protect personal information when you use the Furbabies.AI platform, website, mobile applications, Furbot chatbot, and all related services (collectively, the "Service").

This Policy applies to all users globally, including users in jurisdictions covered by GDPR, CCPA/CPRA, LGPD, PIPEDA, India's DPDPA, UK GDPR, and other applicable laws.

BY USING THE SERVICE, YOU EXPRESSLY CONSENT TO THE DATA PRACTICES DESCRIBED IN THIS POLICY, INCLUDING THE COLLECTION AND USE OF YOUR UPLOADED PHOTOS, VIDEOS, AND CHAT DATA FOR AI TRAINING AND COMMERCIAL RESEARCH PURPOSES.

If you do not agree to this Policy, you must not use the Service.`,
  },
  {
    number: "2",
    title: "Data Controller Information",
    content: `The data controller responsible for your personal data is:

Furbabies Inc.
495 Grand Blvd #206, Miramar Beach, FL 32550, United States
Email: social@furbabies.ai

For EU/EEA data subjects: Furbabies Inc. serves as both data controller and, where applicable, data processor. EU/EEA users may contact us at social@furbabies.ai regarding GDPR Article 27 representative designation. We are in the process of appointing a formal EU GDPR representative and will update this Policy accordingly.

For UK users: Furbabies complies with the UK GDPR and Data Protection Act 2018. UK users may direct privacy enquiries to social@furbabies.ai.`,
  },
  {
    number: "3",
    title: "Information We Collect",
    subsections: [
      {
        title: "3.1 Information You Provide Directly",
        content: `We collect the following personal information you voluntarily provide:

• Account Registration Data: Name, email address, and password.
• Payment Information: Payment card details, billing address, and related data. Full card data is processed exclusively by Stripe, Inc.; Furbabies retains only tokenized identifiers.
• Pet Registration Data: Species, breed, age, weight, sex, health history, dietary restrictions, and other pet information.
• User Content: All photos, videos, and other media uploaded to the Service, including images of your pet, pet excretions, skin conditions, food items, and nutritional labels.
• Chat and Interaction Data: All messages, queries, and interactions with the Service, including all Furbot conversations. THESE ARE STORED PERMANENTLY FOR RESEARCH AND COMMERCIAL PURPOSES.
• Communications: All emails, messages, or other communications sent to us.`,
      },
      {
        title: "3.2 Information Collected Automatically",
        content: `When you use the Service we automatically collect:

• Device and Technical Data: IP address, device type, operating system, browser type and version, device identifiers, and hardware specifications.
• Usage Data: Pages visited, features used, time and duration of access, referring URLs, clickstream data, and feature interaction logs.
• Location Data: General geographic location inferred from IP address. We do not collect precise GPS location unless you explicitly provide it.
• Cookies and Tracking Technologies: As described in our Cookie Policy.
• Log Data: Server logs including error reports, access times, and performance data.`,
      },
      {
        title: "3.3 Inferred and Derived Data",
        content: `We may generate inferred data about you and your pet(s) based on your interactions with the Service, including behavioral patterns, engagement preferences, pet health trend data, and user segmentation data. Inferred data may be used for service personalization and commercial development.`,
      },
      {
        title: "3.4 Special Categories of Data",
        content: `Uploaded images and videos of pets may incidentally contain images of you or other individuals. We treat any incidentally collected biometric or personal data with heightened care. We do not intentionally collect health data about humans; however, to the extent any human health-related information is included in uploaded content, we treat such data as sensitive personal information subject to additional protections under applicable law.`,
      },
      {
        title: "3.5 Data We Do NOT Collect",
        content: `We do not intentionally collect:
• Personal data from individuals under 18 years of age.
• Government identification numbers (e.g., Social Security Numbers, passport numbers) unless required for identity verification.
• Precise real-time location data unless explicitly provided.
• Financial account credentials (full payment card numbers are handled exclusively by Stripe).`,
      },
    ],
  },
  {
    number: "4",
    title: "How We Use Your Information",
    content: `We use information we collect for the following purposes:

• Service Delivery: To provide, operate, and personalize the Service, including processing uploaded content through AI models to generate pet health and nutrition guidance.
• Account Management: To create and manage your account, process your subscription, and provide customer support.
• Payment Processing: To facilitate subscription billing through Stripe.
• AI Model Training and Research: To train, improve, test, and develop our AI models and algorithms. All uploaded photos, videos, and chat data are stored for research and commercial development purposes. Where required by applicable law, we rely on your explicit consent or legitimate interests as the legal basis for this use.
• Commercial Development: To develop new products and services, improve existing features, and analyze usage patterns for business development. De-identified or aggregated data may be shared with research or commercial partners.
• Communications: To send service-related notices, subscription confirmations, policy updates, and—where you have opted in—promotional communications.
• Legal Compliance: To comply with applicable laws, respond to lawful requests, enforce our Terms, and protect our legal rights.
• Safety and Fraud Prevention: To detect, investigate, and prevent fraudulent or illegal activity and ensure Service security.
• Age Verification and Child Safety: To verify that users meet the 18+ age requirement and to identify and remove underage users.`,
  },
  {
    number: "5",
    title: "Legal Bases for Processing (GDPR / Global)",
    content: `For users in the EEA, UK, and other jurisdictions requiring specified legal bases:

• Performance of Contract (Art. 6(1)(b) GDPR): Processing necessary to deliver the Service, including account creation, subscription management, and AI-generated pet guidance.
• Legitimate Interests (Art. 6(1)(f) GDPR): Processing for AI model improvement, fraud prevention, security, age verification, and business development, where our interests do not override your fundamental rights.
• Consent (Art. 6(1)(a) GDPR): For marketing communications, AI training on your specific content where required, cookie usage, and processing of special category data. You may withdraw consent at any time without affecting prior processing.
• Legal Obligation (Art. 6(1)(c) GDPR): Where processing is required by applicable law, including COPPA compliance and fraud prevention obligations.
• Special Categories (Art. 9 GDPR): To the extent any uploaded content constitutes special category data, processing is based on your explicit consent provided at registration and through use of the Service.`,
  },
  {
    number: "6",
    title: "Data Sharing and Disclosure",
    subsections: [
      {
        title: "6.1 Service Providers",
        content: `We share personal data with trusted third-party service providers who assist in operating the Service, including Stripe, Inc. for payment processing; AI Model Providers who power our AI functionality; Cloud Storage and Infrastructure Providers; and Analytics Providers. All service providers are contractually required to process personal data only as instructed by Furbabies and to maintain appropriate security measures.`,
      },
      {
        title: "6.2 Research Partners and Commercial Use",
        content: `Aggregated or de-identified data derived from user interactions, uploaded content, and AI model outputs may be shared with research partners, academic institutions, or commercial partners. We will not share individually identifiable personal information for such purposes without your explicit consent, except as described in this Policy.

You expressly acknowledge through your use of the Service and acceptance of our Terms that your uploaded content and interaction data may be used in this manner.`,
      },
      {
        title: "6.3 Legal and Safety Disclosures",
        content: `We may disclose personal data if required by law, subpoena, court order, or governmental authority, or if we believe disclosure is necessary to protect our rights, protect your safety or the safety of others, investigate fraud, respond to a government request, or comply with COPPA-related obligations including reporting of child safety violations.`,
      },
      {
        title: "6.4 Business Transfers",
        content: `In the event of a merger, acquisition, reorganization, bankruptcy, or sale of assets, your personal data may be transferred to an acquiring entity. We will provide notice of any such transfer and material changes to applicable privacy practices.`,
      },
      {
        title: "6.5 No Sale of Personal Data",
        content: `Furbabies does not sell, rent, or lease your personal information to third parties for their independent marketing purposes. For California users: we do not "sell" or "share" personal information as defined under CCPA/CPRA, except as otherwise disclosed in this Policy.`,
      },
      {
        title: "6.6 Disclosure Involving Minors",
        content: `If we discover that personal data of an individual under 18 has been collected, we may disclose such data to: (a) parents or legal guardians upon verified request; (b) law enforcement or child protection authorities where required by law or where there is a reasonable belief of risk to the minor; or (c) service providers assisting in data deletion. We will not otherwise disclose such data.`,
      },
    ],
  },
  {
    number: "7",
    title: "International Data Transfers",
    content: `Furbabies is based in the United States. If you access the Service from outside the US, your data will be transferred to, stored in, and processed in the United States, where privacy laws may differ from those in your jurisdiction.

We implement appropriate safeguards for transfers from the EU/EEA, UK, Switzerland, and other jurisdictions:
• EU/EEA transfers: We rely on Standard Contractual Clauses (SCCs) approved by the European Commission.
• UK transfers: We use the UK's International Data Transfer Agreement (IDTA) or UK Addendum to SCCs.
• Other jurisdictions: We implement appropriate contractual or organizational safeguards as required by applicable law.

By using the Service, you expressly consent to the transfer of your data to the United States and other countries for the purposes described in this Policy.`,
  },
  {
    number: "8",
    title: "Data Retention",
    content: `We retain your personal data for as long as your account is active and for such period as necessary to fulfill the purposes described in this Policy:

• Account and Registration Data: Duration of account plus seven (7) years following account closure.
• Uploaded Photos, Videos, and Chats: Retained indefinitely for research and commercial purposes, unless you request deletion and deletion is not precluded by legal obligation.
• Payment Records: Seven (7) years as required by financial regulations.
• Communications: Five (5) years.
• Log and Technical Data: Up to two (2) years.
• Data of Underage Users: Deleted promptly upon discovery, subject to any mandatory reporting obligations.

YOU EXPRESSLY ACKNOWLEDGE THAT UPLOADED PHOTOS, VIDEOS, AND CHAT DATA MAY BE RETAINED INDEFINITELY FOR AI RESEARCH AND COMMERCIAL PURPOSES EVEN AFTER ACCOUNT CLOSURE, SUBJECT TO APPLICABLE LAW AND YOUR DELETION RIGHTS.

You may request deletion of your personal data as described in Section 9. Certain data may be retained beyond your request where required by legal obligation or legitimate business interest.`,
  },
  {
    number: "9",
    title: "Your Privacy Rights",
    subsections: [
      {
        title: "9.1 Rights Available to All Users",
        content: `Regardless of location, you have the right to: Access (request a copy of personal data we hold about you); Correction (request correction of inaccurate data); Deletion (request deletion, subject to lawful retention requirements); Objection (object to certain processing activities); and Opt-Out of Marketing (opt out of promotional communications at any time by clicking "unsubscribe" in any marketing email or contacting us).`,
      },
      {
        title: "9.2 Additional Rights for EEA / UK Users (GDPR / UK GDPR)",
        content: `EEA and UK users additionally have the right to: Restriction of Processing; Data Portability (receive your data in a structured, machine-readable format); Objection to processing based on legitimate interests or direct marketing; Protection from Solely Automated Decision-Making with significant effects; Withdrawal of Consent at any time; and Lodge a Complaint with your local data protection supervisory authority (e.g., your national DPA or the UK ICO).`,
      },
      {
        title: "9.3 California Rights (CCPA/CPRA)",
        content: `California residents have the right to: Know (disclosure of categories and specific pieces of personal information collected, used, disclosed, or sold); Delete; Correct; Opt-Out of Sale/Sharing; Limit Use of Sensitive Personal Information; Non-Discrimination for exercising privacy rights; and Opt-Out via the Global Privacy Control (GPC), which we honor.`,
      },
      {
        title: "9.4 Brazilian Rights (LGPD)",
        content: `Brazilian users have the right to confirmation of processing, access, correction, anonymization or deletion, portability, information about sharing, the right to not consent or revoke consent, and the right to lodge a complaint with Brazil's ANPD.`,
      },
      {
        title: "9.5 Rights of Parents and Guardians",
        content: `Parents and legal guardians have the right to: (a) request access to or deletion of personal data collected from their minor child; (b) refuse further collection or use of their child's data; and (c) request that we notify them prior to any material change in data practices affecting their child's data. To exercise these rights, contact social@furbabies.ai with subject line "Minor Data Request" and provide verifiable proof of guardianship.`,
      },
      {
        title: "9.6 Exercising Your Rights",
        content: `To exercise any rights described in this section, submit a verifiable request to social@furbabies.ai. We will respond within the timeframe required by applicable law (generally 30–45 days, subject to extension where permitted). We may require identity verification before processing your request. We will not discriminate against you for exercising your privacy rights.`,
      },
    ],
  },
  {
    number: "10",
    title: "Children's Privacy — 18+ Service Only",
    highlight_section: true,
    content: `THE SERVICE IS STRICTLY FOR USERS 18 YEARS OF AGE OR OLDER. WE DO NOT KNOWINGLY COLLECT, USE, OR DISCLOSE PERSONAL INFORMATION FROM INDIVIDUALS UNDER THE AGE OF 18.

COPPA Compliance: This Service is not directed at children under 13. We strictly comply with the Children's Online Privacy Protection Act (COPPA), 15 U.S.C. § 6501 et seq., and the COPPA Rule (16 C.F.R. Part 312). We do not knowingly collect personal information from children under 13.

International Compliance: We comply with equivalent child protection laws globally, including GDPR Article 8 (EU/EEA), UK GDPR, PIPEDA (Canada), and PDPA (Thailand).

Discovery of Underage Users: If we discover or have reason to believe that a user is under 18:
• We will immediately suspend and terminate the account.
• We will delete all personal data associated with the account.
• We will issue a full refund of any subscription fees paid.
• We may notify relevant authorities where required by law.

Parental Rights: Parents and guardians may contact social@furbabies.ai with subject line "Minor Account Report" to report suspected underage use, request data deletion, or exercise parental rights under COPPA or applicable law. We will respond within five (5) business days.

Verification: We reserve the right to verify the age of any user at any time. Refusal to provide age verification will result in account suspension.`,
  },
  {
    number: "11",
    title: "Data Security",
    content: `We implement commercially reasonable technical and organizational security measures to protect your personal data, including:

• Encryption of data in transit using TLS/SSL protocols.
• Encryption of data at rest using industry-standard encryption.
• Access controls limiting data access to authorized personnel only.
• Regular security assessments and penetration testing.
• Secure cloud infrastructure with redundancy and backup systems.
• Employee training on data protection and security practices.

HOWEVER, NO METHOD OF TRANSMISSION OVER THE INTERNET OR ELECTRONIC STORAGE IS COMPLETELY SECURE. WE CANNOT GUARANTEE ABSOLUTE SECURITY OF YOUR DATA. You acknowledge and accept this inherent risk.

Data Breach Notification: In the event of a breach likely to result in risk to your rights and freedoms, we will notify you and relevant authorities as required by applicable law (e.g., within 72 hours under GDPR, without undue delay under CCPA).

Security Incidents: To report a security vulnerability or suspected breach, contact social@furbabies.ai immediately.`,
  },
  {
    number: "12",
    title: "AI-Specific Data Practices",
    content: `Given the AI-driven nature of our Service, the following additional practices apply:

• Model Training: Your uploaded photos, videos, and chat interactions may be used to train, fine-tune, test, and validate our AI models. This training helps improve the accuracy and quality of AI-generated outputs.
• No Reverse Identification: We implement technical measures designed to prevent re-identification of individuals from de-identified training data. However, we cannot guarantee that re-identification is technically impossible in all circumstances.
• AI Output Storage: AI-generated responses to your queries may be stored alongside your input data for quality assurance, research, and service improvement.
• Human Review: Portions of uploaded content or AI outputs may be reviewed by Furbabies employees or contractors for quality control, safety monitoring, and model improvement purposes, subject to confidentiality obligations.
• Opt-Out of AI Training: Where required by applicable law (including GDPR Article 21), you may object to use of your personal data for AI training by contacting social@furbabies.ai. We will evaluate such requests on a case-by-case basis. Note that opting out of AI training may limit your access to certain features of the Service.`,
  },
  {
    number: "13",
    title: "Jurisdiction-Specific Provisions",
    content: `• EU/EEA: Our processing is subject to GDPR and supervision by relevant EU data protection authorities. You may exercise your rights under GDPR by contacting social@furbabies.ai.
• United Kingdom: We comply with the UK GDPR and Data Protection Act 2018. UK users may contact the Information Commissioner's Office (ICO) at ico.org.uk.
• Canada: We comply with PIPEDA and applicable provincial privacy laws. Canadian users may contact the Office of the Privacy Commissioner of Canada (priv.gc.ca).
• India: We comply with India's Digital Personal Data Protection Act (DPDPA) to the extent applicable.
• Australia: We comply with the Australian Privacy Act 1988 and Australian Privacy Principles. Users may contact the Office of the Australian Information Commissioner (oaic.gov.au).
• Brazil: We comply with LGPD. Brazilian users may lodge complaints with the ANPD (gov.br/anpd).
• California: We comply with CCPA/CPRA. California users have additional rights as described in Section 9.3.`,
  },
  {
    number: "14",
    title: "Cookies and Tracking",
    content: `We use cookies and similar tracking technologies as described in our Cookie Policy, incorporated herein by reference. You can manage cookie preferences through your browser settings or our cookie consent tool.

We do not use tracking technologies to collect personal data from individuals under 18. If we discover that tracking data has been collected from a minor, we will promptly delete it.`,
  },
  {
    number: "15",
    title: "Changes to This Privacy Policy",
    content: `We may update this Privacy Policy to reflect changes in data practices, applicable law, or business operations. We will provide notice of material changes by posting the updated Policy on the Service and updating the effective date. For significant changes affecting your rights, we will provide email notice where practicable.

Your continued use of the Service after the effective date of any updated Policy constitutes acceptance of the changes. If you do not agree to a material change, you must stop using the Service before the effective date of the change.`,
  },
  {
    number: "16",
    title: "Contact Us and Data Protection Officer",
    content: `For privacy inquiries, rights requests, data deletion requests, or to report a minor's account:

Furbabies Inc.
495 Grand Blvd #206, Miramar Beach, FL 32550
Email: social@furbabies.ai

Minor Account Reports: social@furbabies.ai (Subject: "Minor Account Report")
Security Issues: social@furbabies.ai (Subject: "Security Report")

We will respond to all privacy-related inquiries within thirty (30) days. For urgent matters involving minors or data breaches, we will respond within five (5) business days.

If you are not satisfied with our response, you have the right to lodge a complaint with your local data protection supervisory authority.`,
  },
];

const SectionBlock = ({ section, index }) => {
  const [open, setOpen] = useState(true);
  const isChild = section.number === "10";

  const headerBg    = isChild ? "linear-gradient(135deg,#fff5f5,#fef2f2)" : "#f4ede7";
  const headerHover = isChild ? "linear-gradient(135deg,#fee2e2,#fef2f2)" : "#ede4db";
  const borderCol   = isChild ? "rgba(220,38,38,0.35)" : "#e8ddd6";
  const numBg       = isChild ? "#dc2626" : "#967d6c";
  const chevronCol  = isChild ? "#dc2626" : "#967d6c";

  return (
    <motion.div
      initial={{ opacity:0, y:20 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true }}
      transition={{ duration:0.5, delay: index * 0.04 }}
      className="mb-4 rounded-2xl overflow-hidden"
      style={{ border:`1.5px solid ${borderCol}` }}
    >
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-6 py-4 text-left transition-colors"
        style={{ background: headerBg }}
        onMouseEnter={e => e.currentTarget.style.background = headerHover}
        onMouseLeave={e => e.currentTarget.style.background = headerBg}
      >
        <div className="flex items-center gap-4 flex-wrap">
          <span className="w-8 h-8 rounded-full text-white text-sm font-bold flex items-center justify-center flex-shrink-0"
            style={{ background: numBg }}>{section.number}</span>
          <h2 className="text-lg font-bold text-gray-800">{section.title}</h2>
          {isChild && (
            <span style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"3px 10px", borderRadius:99, background:"rgba(220,38,38,0.10)", border:"1px solid rgba(220,38,38,0.30)", fontSize:10, fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", color:"#dc2626", marginLeft:6, flexShrink:0 }}>
              ⚠ COPPA
            </span>
          )}
        </div>
        <span className={`text-xl transition-transform duration-200 flex-shrink-0 ml-3 ${open ? "rotate-180" : ""}`}
          style={{ color: chevronCol }}>▾</span>
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div initial={{ height:0, opacity:0 }} animate={{ height:"auto", opacity:1 }} exit={{ height:0, opacity:0 }}
            transition={{ duration:0.25, ease:"easeInOut" }} style={{ overflow:"hidden" }}>
            <div className={`px-6 py-5 ${isChild ? "bg-[#fff5f5]" : "bg-white"}`}>
              {section.content && <p className="text-gray-600 poppins-text text-sm leading-7 whitespace-pre-line">{section.content}</p>}
              {section.subsections && section.subsections.map((sub, i) => (
                <div key={i} className={`mb-5 last:mb-0 ${sub.highlight ? "bg-[#fdf8f5] border-l-4 border-[#967d6c] pl-4 pr-3 py-3 rounded-r-xl" : ""}`}>
                  <h3 className="text-sm font-bold text-gray-800 mb-2">{sub.title}</h3>
                  <p className="text-gray-600 poppins-text text-sm leading-7 whitespace-pre-line">{sub.content}</p>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

const PrivacyPolicy = () => (
  <>
    <Helmet>
      <title>Privacy Policy — Furbabies.AI</title>
      <meta name="description" content="Read the Furbabies.AI Privacy Policy." />
    </Helmet>
    <Navbar />
    <div className="min-h-screen bg-white pt-28 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

        <motion.div initial={{ opacity:0, y:30 }} animate={{ opacity:1, y:0 }} transition={{ duration:0.7 }}
          className="mb-12 text-center mt-20">
          <p className="text-[#967d6c] font-semibold poppins-text text-sm uppercase tracking-widest mb-3">Legal</p>
          <h1 className="text-5xl lg:text-[60px] lg:leading-[70px] font-bold text-gray-900 mb-4">Privacy Policy</h1>
          <p className="poppins-text text-gray-500 text-sm">Effective Date: March 10, 2026 &nbsp;·&nbsp; Last Updated: March 10, 2026</p>
          <div className="mt-4 inline-block bg-[#fdf8f5] border border-[#e8ddd6] rounded-full px-5 py-2">
            <p className="text-xs poppins-text text-gray-500">
              Furbabies Inc. · 495 Grand Blvd #206, Miramar Beach, FL 32550 ·{" "}
              <a href="mailto:social@furbabies.ai" className="text-[#967d6c] hover:underline">social@furbabies.ai</a>
            </p>
          </div>
        </motion.div>

        {/* Intro notice */}
        <motion.div initial={{ opacity:0 }} animate={{ opacity:1 }} transition={{ delay:0.3, duration:0.6 }}
          className="mb-5 bg-[#f4ede7] border border-[#e8ddd6] rounded-2xl px-6 py-5">
          <p className="text-sm text-gray-700 poppins-text leading-7">
            This Privacy Policy explains how Furbabies Inc. collects, uses, shares, and protects your personal information and that of your pet(s). <strong>Uploaded photos, videos, and chat data are stored for AI research and commercial purposes.</strong> Please read this Policy carefully before using the Service.
          </p>
        </motion.div>

        {/* 18+ age notice */}
        <motion.div initial={{ opacity:0, y:10 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.45, duration:0.55 }}
          className="mb-8 rounded-2xl px-6 py-5"
          style={{ background:"linear-gradient(135deg,#fff5f5,#fef2f2)", border:"1.5px solid rgba(220,38,38,0.30)" }}>
          <div style={{ display:"flex", alignItems:"flex-start", gap:14 }}>
            <div style={{ width:40, height:40, borderRadius:10, background:"#dc2626", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0 }}>🔞</div>
            <div>
              <p style={{ fontSize:13, fontWeight:800, color:"#dc2626", letterSpacing:"0.06em", textTransform:"uppercase", marginBottom:6 }}>18+ Only — No Data Collection from Minors</p>
              <p style={{ fontSize:14, color:"#7f1d1d", lineHeight:1.72, margin:0 }}>
                This Service is strictly for users 18 and older. We do not knowingly collect personal data from individuals under 18. See <strong>Section 10</strong> for our COPPA compliance details and parental rights.
              </p>
            </div>
          </div>
        </motion.div>

        {sections.map((section, i) => <SectionBlock key={i} section={section} index={i} />)}

        <motion.div initial={{ opacity:0, y:20 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true }}
          className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { label:"Terms & Conditions", to:"/terms",        desc:"Our terms of service and user agreement" },
            { label:"Cookie Policy",      to:"/cookie-policy", desc:"How we use cookies and tracking" },
          ].map(item => (
            <Link key={item.to} to={item.to}
              className="flex items-center justify-between bg-[#f4ede7] hover:bg-[#ede4db] transition-colors rounded-2xl px-6 py-4 group">
              <div>
                <p className="font-bold text-gray-800 text-sm">{item.label}</p>
                <p className="text-xs text-gray-500 poppins-text mt-0.5">{item.desc}</p>
              </div>
              <span className="text-[#967d6c] text-lg group-hover:translate-x-1 transition-transform">→</span>
            </Link>
          ))}
        </motion.div>

      </div>
    </div>
    <Footer />
  </>
);

export default PrivacyPolicy;